import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';
import type {
  PtShopConfirmation as Props,
  Section as SectionProps,
} from './pt-shop-confirmation.types';

const Section: React.FC<SectionProps> = ({ entries, title }) =>
  entries.length ? (
    <div className="pt-shop-confirmation__section">
      <div className="pt-shop-confirmation__title">
        <Text size={Text.sizes.large} theme={Text.themes.headline}>
          {title}
        </Text>
      </div>
      <dl>
        {entries.map(entry => (
          <React.Fragment key={entry.name}>
            <Text elementName="dt" theme={Text.themes.emphasis} tight>
              {entry.name}
            </Text>
            <Text elementName="dd" tight>
              {entry.value}
            </Text>
          </React.Fragment>
        ))}
      </dl>
    </div>
  ) : null;

// eslint-disable-next-line react/no-multi-comp
const PtShopConfirmation: React.FC<Props> = ({
  body,
  debug,
  layout,
  payment,
  product,
}) => (
  <FlowTerminusLayout {...layout}>
    <div className="pt-shop-confirmation">
      <div className="pt-shop-confirmation__body">
        {body.map((entry, index) => (
          <Text
            key={entry}
            size={index ? Text.sizes.interface : Text.sizes.basic}
          >
            {entry}
          </Text>
        ))}
      </div>
      <div className="pt-shop-confirmation__sections">
        <Section {...product} />
        <Section {...payment} />
      </div>
      {debug ? (
        <code>
          <pre>{debug}</pre>
        </code>
      ) : null}
    </div>
  </FlowTerminusLayout>
);

export default PtShopConfirmation;
